<!-- -------------------------------------------------------------- -->
<!-- Add/Edit Event on calendar -->
<!-- -------------------------------------------------------------- -->

<div mat-dialog-content>
  <div class="d-flex align-items-center justify-content-between m-b-16">
    <h4 class="f-s-16 f-w-600 m-b-16">{{ data?.action }}</h4>
    <button
      mat-icon-button
      mat-dialog-close
      class="d-flex justify-content-center"
    >
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

  @if(data?.action === 'Edit') {
  <div class="basic-form">
    <div class="row">
      <!-- col -->
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            placeholder="Edit Title"
            [(ngModel)]="data?.event.title"
          />
        </mat-form-field>
      </div>
      <!-- col -->
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            placeholder="Change Color"
            type="color"
            [(ngModel)]="data?.event.color.primary"
          />
        </mat-form-field>
      </div>
      <!-- col -->
      <div class="col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [matDatepicker]="startDateDP"
            placeholder="Start Date"
            name="startDate"
            [(ngModel)]="data?.event.start"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDateDP"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDateDP></mat-datepicker>
        </mat-form-field>
      </div>
      <!-- col -->
      <div class="col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [matDatepicker]="endDateDP"
            placeholder="End Date"
            name="endDate"
            [(ngModel)]="data?.event.end"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endDateDP"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDateDP></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  }
  <div class="d-flex align-items-center gap-12">
    <button mat-flat-button color="primary" (click)="dialogRef.close()">
      Okay
    </button>
    <button mat-button mat-dialog-close class="bg-error text-white">
      Cancel
    </button>
  </div>
</div>
